import React from "react";
import BondNode from "components/BondTree/Node";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSignal} from "@fortawesome/free-solid-svg-icons";

function DeviceCommand(props) {
  function tx() {
    props.bond.commandTx(props.path).then((response) => {
    });
  }

  function customAttr(attr, value) {
    switch (attr) {
      case "tx":
        return (
          <li key={attr}>
            <Button variant={"outline-success"} onClick={tx}><FontAwesomeIcon icon={faSignal}/> Tx Now</Button>
          </li>
        );
      default:
        return null;
    }
  }

  return <BondNode {...props} customAttrComponent={customAttr} />;
}

export default DeviceCommand;
